export default __webpack_public_path__ + "static/media/Logo Albatros.841aae45.png";